(() => {
  function imageSrc(image) {
    return image.currentSrc || image.src || image.getAttribute("src");
  }

  function showInMain(gallery, thumb) {
    const mainWrap = gallery.querySelector(".product-main-hover-wrap");
    const mainImage = mainWrap && mainWrap.querySelector(".product-primary-image");
    if (!mainImage || !thumb) return;

    const src = imageSrc(thumb);
    if (!src) return;

    mainImage.src = src;
    mainImage.removeAttribute("srcset");
    mainImage.removeAttribute("sizes");
    mainImage.alt = thumb.alt || mainImage.alt;

    const hoverImage = mainWrap.querySelector(".product-main-hover-image");
    if (hoverImage) {
      hoverImage.src = src;
      hoverImage.removeAttribute("srcset");
      hoverImage.removeAttribute("sizes");
      hoverImage.alt = thumb.alt || hoverImage.alt;
    }

    gallery.querySelectorAll(".gallery-thumb-active").forEach((item) => item.classList.remove("gallery-thumb-active"));
    thumb.classList.add("gallery-thumb-active");
    mainWrap.classList.add("gallery-image-selected");
  }

  function setupGallery(gallery) {
    if (!gallery || gallery.dataset.gallerySwitcherReady === "true") return;
    gallery.dataset.gallerySwitcherReady = "true";

    const thumbnails = gallery.querySelectorAll(".scene-gallery img, .product-gallery > img:not(.product-primary-image):not(.product-hover-image)");
    thumbnails.forEach((thumb) => {
      thumb.classList.add("gallery-thumb");
      thumb.setAttribute("role", "button");
      thumb.setAttribute("tabindex", "0");
      thumb.setAttribute("aria-label", "Show this image larger");
      thumb.addEventListener("click", () => showInMain(gallery, thumb));
      thumb.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          showInMain(gallery, thumb);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll(".product-gallery").forEach(setupGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

/* ELARLACE runtime product image fix 20260730 start */
(function () {
  var safeImages = {
    "201ea09": "https://cdn.shopify.com/s/files/1/0813/5435/9010/files/201EA09-cover-safe-product-page.png?v=1785380737"
  };

  function applyMainImageLayout(wrap, img) {
    if (wrap) {
      wrap.style.width = "100%";
      wrap.style.height = "auto";
      wrap.style.aspectRatio = "1 / 1";
      wrap.style.display = "flex";
      wrap.style.alignItems = "center";
      wrap.style.justifyContent = "center";
      wrap.style.background = "#fff";
      wrap.style.overflow = "hidden";
    }
    if (img) {
      img.style.width = "100%";
      img.style.height = "100%";
      img.style.maxWidth = "100%";
      img.style.maxHeight = "100%";
      img.style.objectFit = "contain";
      img.style.objectPosition = "center";
      img.style.boxSizing = "border-box";
      img.style.padding = "clamp(16px, 2.2vw, 32px)";
      img.style.background = "#fff";
    }
  }

  function fixProductMainImage() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    var handle = match[1].toLowerCase();
    var wrap = document.querySelector(".product-main-hover-wrap");
    var img = wrap && wrap.querySelector(".product-primary-image");
    applyMainImageLayout(wrap, img);
    if (!img || !safeImages[handle]) return;
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");
    img.src = safeImages[handle];
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fixProductMainImage);
  } else {
    fixProductMainImage();
  }
})();
/* ELARLACE runtime product image fix 20260730 end */
